<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" md="8">
                <v-card flat>
                    <v-card-text>
                        <v-form>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                            outlined
                                            label="Document Rule Name"
                                            v-model="$v.editedItem.name.$model"
                                            :error-messages="documentNameError"
                                            error-count=2
                                            hint="ie. Driver License"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-switch label="Document is Required"
                                                      v-model="$v.editedItem.required.$model">
                                            </v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-switch label="Document requires approval"
                                                      v-model="$v.editedItem.approvalRequired.$model">
                                            </v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-switch label="Document can expire"
                                                      v-model="$v.documentExpires.$model">
                                            </v-switch>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="1" class="d-none d-md-flex" v-if="documentExpires">
                                    <v-divider vertical inset></v-divider>
                                </v-col>
                                <v-col xs="12" md="7" v-if="documentExpires">
                                        <v-row>
                                            <v-col sm-12 md-6>
                                                <v-text-field
                                                        outlined
                                                        label="Expiration interval"
                                                        v-mask="documentInterval.textMask"
                                                        v-model="documentInterval.text"
                                                        :error-messages="documentExpiredError"
                                                        hint="ie. 5, 30, 180"
                                                        :disabled="!documentExpires"
                                                        required>
                                                </v-text-field>
                                            </v-col>
                                            <v-col sm-12 md-6>
                                                <v-select
                                                        outlined
                                                        :items="documentInterval.selectorOptions"
                                                        :disabled="!documentExpires"
                                                        :value="documentInterval.selected"
                                                        @change="documentInterval.selected = $event"
                                                >
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col sm-12 md-6>
                                                <v-text-field
                                                        outlined
                                                        label="Expiration notification interval"
                                                        v-mask="documentInterval.textMask"
                                                        v-model="documentNotifyInterval.text"
                                                        :error-messages="documentExpiredNotifyError"
                                                        hint="ie. 5, 30, 180"
                                                        :disabled="!documentExpires"
                                                        required>
                                                </v-text-field>
                                            </v-col>
                                            <v-col sm-12 md-6>
                                                <v-select
                                                        outlined
                                                        :items="documentInterval.selectorOptions"
                                                        :disabled="!documentExpires"
                                                        :value="documentNotifyInterval.selected"
                                                        @change="documentNotifyInterval.selected = $event"
                                                >
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="6" sm="2">
                                    <v-btn color="default" text @click="close">Cancel</v-btn>
                                </v-col>
                                <v-col cols="6" sm="2">
                                    <v-btn color="primary"
                                           :loading="isSaving"
                                           :disabled="isSaving"
                                           @click="save">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <dialog-alert :text="alertText"
                      :alert-type="alertType"
                      :open="openAlert"
                      @alert-closed="alertClosed($event)">
        </dialog-alert>
        <dialog-alert :text="notFoundError"
                      :alert-type="alertTypes.ERROR"
                      :open="openNotFound"
                      @alert-closed="close()">
        </dialog-alert>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    import { required, maxLength, minLength, requiredIf, between} from 'vuelidate/lib/validators';
    import {DocumentRule} from '../../../shared/dtos/Dtos';
    import {DOCUMENT_RULE_TYPES} from "../../../shared/enums/DocumentRule";
    import { FORM_STATUS } from '../../../shared/enums/FormStatuses';
    const datePicker = ()=> import( '@/components/common/DatePicker');
    const DialogAlert = ()=> import( '@/components/common/DialogAlert');
    import {formUnsavedMixin} from "../../../shared/mixins/FormUnsaved";
    import { ALPHA_NUMERIC_WITH_SPACES_VALIDATOR } from "../../../shared/validators/Validators";
    import {WRONG_ID_SUPPLIED}  from "../../../shared/enums/AlertTexts";
    import {ALERT_TYPES} from "../../../shared/enums/AlertTexts";

    export default {
        name: "documentRuleForm",
        mixins:[formUnsavedMixin],
        props:['id', 'path_type'],
        components:{
            datePicker, DialogAlert
        },
        data(){
            return {
                editedItem: {},
                documentExpires: false,
                documentInterval: {
                    text: '',
                    textMask: '###',
                    selectorOptions:['days', 'months', 'years'],
                    selected:'days'
                },
                documentNotifyInterval: {
                    text: '',
                    selectorOptions:['days', 'months', 'years'],
                    selected:'days'
                },
                isSaving: false,
                notFoundError: WRONG_ID_SUPPLIED,
                openNotFound: false,
                alertTypes: ALERT_TYPES
            };
        },
        validations: {
            editedItem:{
                name: {
                    required: required,
                    minLength: minLength(2),
                    ALPHA_NUMERIC_WITH_SPACES_VALIDATOR
                },
                required: {},
                approvalRequired: {}
            },
            documentInterval: {
                text:{
                    required: requiredIf(function (nestedModel) {
                        return this.documentExpires;
                    }),
                    maxLength: maxLength(3)
                }
            },
            documentExpires: {},
            documentNotifyInterval: {
                text:{
                    required: requiredIf(function (nestedModel) {
                        return this.documentExpires;
                    }),
                    maxLength: maxLength(3),
                    between(value){
                        if(!this.documentExpires || !this.documentInterval.text)
                            return true;

                        let totalDaysExpiration = this.getDaysInInterval(this.documentInterval.selected) * this.documentInterval.text;
                        let totalDaysNotification = this.getDaysInInterval(this.documentNotifyInterval.selected) * this.documentNotifyInterval.text;

                        return between(0, totalDaysExpiration)(totalDaysNotification);
                    }
                }
            },
        },
        computed:{
            documentNameError(){
                const errors = [];
                if (!this.$v.editedItem.name.$dirty) {
                    return errors;
                }

                !this.$v.editedItem.name.minLength && errors.push('Name must be at least '+
                    this.$v.editedItem.name.$params.minLength.min +' characters long');
                !this.$v.editedItem.name.required && errors.push('Name is required.');
                !this.$v.editedItem.name.ALPHA_NUMERIC_WITH_SPACES_VALIDATOR && errors.push('Name must contain only letters and numbers.');

                return errors;
            },
            documentExpiredError(){
                const errors = [];
                if (!this.$v.documentInterval.text.$dirty || !this.documentExpires) {
                    return errors;
                }

                !this.$v.documentInterval.text.maxLength && errors.push('Interval must be at max '+
                    this.$v.documentInterval.text.$params.maxLength.max +' characters long');
                !this.$v.documentInterval.text.required && errors.push('A number is required.');
                return errors
            },
            documentExpiredNotifyError(){
                const errors = [];
                if (!this.$v.documentNotifyInterval.text.$dirty || !this.documentExpires) {
                    return errors;
                }

                !this.$v.documentNotifyInterval.text.maxLength && errors.push('Notify interval must be at max '+
                    this.$v.documentNotifyInterval.text.$params.maxLength.max +' characters long');
                !this.$v.documentNotifyInterval.text.required && errors.push('A number is required.');
                !this.$v.documentNotifyInterval.text.between && errors.push('The notification value must by less than '
                    +this.documentInterval.text+' '+this.documentInterval.selected+'.');
                return errors
            },
            documentType(){
                return this.path_type;
            }
        },
        methods:{
            async initialize(){
                this.editedItem = {...DocumentRule};

                if(this.id !== undefined)
                {
                    await this.$store.dispatch('getDocumentRule',{id: this.id});
                    this.editedItem = this.$store.getters.getDocumentRule;

                    if(this.editedItem.hasOwnProperty('id'))
                    {
                        delete this.editedItem.id;
                        this.editedItem.name = '';

                        if(this.editedItem.expiredInterval !== '-1')
                        {
                            let interval = this.editedItem.expiredInterval.split('-');
                            this.documentInterval.text = interval[0];
                            this.documentInterval.selected = interval[1];

                            let intervalNotify = this.editedItem.notificationInterval.split('-');
                            this.documentNotifyInterval.text = intervalNotify[0];
                            this.documentNotifyInterval.selected = intervalNotify[1];

                            this.documentExpires = true;
                        }
                    }
                    else
                    {
                        this.openNotFound = true;
                        return;
                    }
                }
                else{
                    this.editedItem.type = DOCUMENT_RULE_TYPES[this.documentType.toUpperCase()];
                }
            },
            close(){
                this.resetValues();
                this.status = FORM_STATUS.CLOSE;

                //going to redirect route
                if(this.$route.query.redirect !== undefined && this.$route.query.redirect !== '')
                {
                    this.$router.push({name:this.$route.query.redirect});
                    return;
                }

                this.$router.push({name: 'documentRuleTable'})
            },
            getDaysInInterval(interval){
                let days = 1;
                switch (interval) {
                    case 'years':
                        days = 365;
                        break;
                    case 'months':
                        days = 30;
                }

                return days;
            },
            resetValues(){
                this.$v.$reset();
                this.editedItem = {...DocumentRule};
                this.$store.commit('setDocumentRule',{});
            },
            async save(){

                this.$v.$touch();

                if(this.$v.$anyError)
                    return;

                this.isSaving = true;

                if(this.documentExpires )
                {
                    this.editedItem.expiredInterval = this.documentInterval.text + '-' + this.documentInterval.selected;
                    this.editedItem.notificationInterval = this.documentNotifyInterval.text + '-' + this.documentNotifyInterval.selected;
                }
                else
                {
                    this.editedItem.expiredInterval = '-1';
                    this.editedItem.notificationInterval = '-1';
                }

                try
                {
                    await this.$store.dispatch('setDocumentRule',this.editedItem);
                    let response = this.$store.getters.getDocumentRule;

                    /**
                     * Updating list of document rules
                     */
                    this.$store.commit('setDocumentRules',[]);
                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    this.isSaving = false;
                    return;
                }

                this.close();
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>